module.exports = __webpack_public_path__ + "img/game_icon_up.8e76af4f.png";